import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

async function fetchClient(token, modelId) {
  const apiUrl = `${apiURL}/admin/client/list`;

  const body = modelId ? { ModelId: modelId } : {};

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  return data.message.list;
}

export default fetchClient;